import script from "./form-service-group.vue?vue&type=script&setup=true&lang=js"
export * from "./form-service-group.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__